// SURVEY SCREEN FOR SURVEYS WITH 2 PARTS

import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';

import Header from './Header.js';
import Disclaimers from './Disclaimers.js';
import QuestionCard from './QuestionCard.js';
import SurveyTwoPartPDF from './SurveyTwoPartPDF.js';

import {adhdCurrentScreenData, adhdChildScreenData, adhdParentScreenData, ocdYBOCSScreenData, insomniaSeverityIndexScreenData, depressionHamDScreenData} from './surveyConsts'; //Import survey consts

import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Fab from '@material-ui/core/Fab';
import Dialog from '@material-ui/core/Dialog';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';

import Slide from '@material-ui/core/Slide';

//import ConfirmDialog from './ConfirmDialog.js'



// STYLES FOR MATERIAL-UI
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
      padding: 20,
      paddingTop:100,
      paddingBottom: 100,
      margin: 'auto',
      maxWidth: 800,
  },
  card: {
    textAlign: 'left',
    color: theme.palette.text.secondary,
      alignItems: 'center',
  },
    button: {
         padding: theme.spacing(2),
      margin: theme.spacing(2),
        alignItems: 'center',
    },
    cardContent: {
        paddingTop: theme.spacing(0),
        paddintBottom: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
      margin: theme.spacing(0),
    },
    cardAction: {
      justifyContent: 'center',  
       paddingTop: theme.spacing(1),
        paddintBottom: theme.spacing(0),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
      margin: theme.spacing(0),
    },
    media: {
        width: 70,
    },
    extendedIcon: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        zIndex: 1000,
    },
}));

// ANIMATIONS FOR MODAL
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  

// SURVEY REACT COMPONENT
export default function SurveyTwoPartScreen(props) {
    const classes = useStyles();
    const [openPDF, setOpenPDF] = useState(false);
    const history = useHistory();
    const [privacyOpen, setPrivacyOpen] = useState(false); // privacy dialog boolean
    const [privacyAgreed, setPrivacyAgreed] = useState(()=>localStorage.getItem("survey-privacy-agreed-v0.3")==="true"); // check if already agreed to privacy this time

    // FIND DATA SOURCE BASED ON ITEM
    let data= {};
    if (props.item==="ADHD-Current") {
        data = adhdCurrentScreenData;
    } else if (props.item==="ADHD-Childhood") {
        data = adhdChildScreenData;
    } else if (props.item==="ADHD-Parents") {
        data = adhdParentScreenData;
    } else if (props.item==="OCD-YBOCS") {
        data = ocdYBOCSScreenData;
    } else if (props.item==="ISI") {
        data = insomniaSeverityIndexScreenData;
    } else if (props.item==="HAMD") {
        data = depressionHamDScreenData;
    } 

    // USESTATES FOR SURVEYS FROM DATA
    const [surveyPartA, setSurveyPartA] = useState(data.surveys[0]);
    const [surveyPartB, setSurveyPartB] = useState(data.surveys[1]);

    // SHOW PRIVACY AGREED IF OPENING SURVETS
    // TO-DO: USE LOCALSTORAGE FOR PERSISTENCE?
    useEffect(()=>{
        if (!privacyAgreed) {
            handlePrivacyOpen();
        } else {
            localStorage.setItem("survey-privacy-agreed-v0.3", "true");
        }
      }, [privacyAgreed]); 

      function handlePrivacyOpen() {
        setPrivacyOpen(true);
      }
    
      function handlePrivacyAgreeClose (event, reason) { // If pt agrees to privacy, allow to move forward to app
        if (reason === 'clickaway') {
            return;
        };
        if (event) {
            event.preventDefault();
        };
        
        setPrivacyAgreed(true);
        setPrivacyOpen(false);
      }
      
      /*
      function handlePrivacyDisagreeClose () { //If pt does not agree to privacy, send back to main screen
        setPrivacyOpen(false);
        history.push("/");
      } */

    // UPDATE SURVEY DATA WHEN DATA CHANGES
    useEffect(()=>{
        setSurveyPartA(data.surveys[0]);
        setSurveyPartB(data.surveys[1]);
        //window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll up when data changes
      }, [data]); 

    // PROCESS SCORES DEPENDING ON TYPE OF SURVEY
    function scoreTypeData() {

        // FUNCTION TO CALCULATE SUBSCORES
        function subScore(surveyData) {
         let score = 0;
            surveyData.map((question)=>score+=question.choice);

            return score;
        }

        // CALCULATE SUB-SCORES
        const scorePartA= subScore(surveyPartA);
        const scorePartB = subScore(surveyPartB);

        if (props.item==="ADHD-Current") { // If Current Symptoms for ADHD

            // Determine specificity (likelihood of ADHD) based on ASRS v1.1
            function likelihood() {
                     let specScore = 0;
                    if (surveyPartA[0].choice>=2) specScore+=1;
                    if (surveyPartA[1].choice>=2) specScore+=1;
                    if (surveyPartA[2].choice>=3) specScore+=1;
                    if (surveyPartA[3].choice>=3) specScore+=1;
                    if (surveyPartA[4].choice>=3) specScore+=1;
                    if (surveyPartA[5].choice>=3) specScore+=1;
        
                    if (specScore>=4) return "High";
        
                    return "Low";
            }

            return [ 
                {
                    name: "Part A Score:",
                    score: scorePartA,
                },
                {
                    name: "Part B Score:",
                    score: scorePartB,
                },
                {
                    name: "Likelihood:",
                    score: likelihood(),
                },
            ]
        } else if (props.item==="ADHD-Childhood") { // If Childhood Symptoms for ADHD
            
            // CALCULATE LIKELIHOOD FOR CHILDHOOD SYMPTOMS
            function likelihood(score){
                if (score <= 16) {
                    return "Unlikely";
                } else if (score >=17 && score <= 23) {
                    return "Likely";
                } else {
                    return "Highly Likely";
                }
            }

            return [ 
                {
                    name: "Part A Score - Inattentive Symptoms: ",
                    score: scorePartA,
                },
                {
                    name: "Part A Likelihood:",
                    score: likelihood(scorePartA),
                },
                {
                    name: "Part B Score - Hyperactive/Impulsive Symptoms:",
                    score: scorePartB,
                },
                {
                    name: "Part B Likelihood:",
                    score: likelihood(scorePartB),
                },
            ]
        }  else if (props.item==="ADHD-Parents") { // If Parents Survey for ADHD
            
            // CALCULATE LIKELIHOOD FOR PARENT'S NOTE OF CHILDHOOD SYMPTOMS 
            function likelihood(score){
                if (score <= 16) {
                    return "Unlikely";
                } else if (score >=17 && score <= 23) {
                    return "Likely";
                } else {
                    return "Highly Likely";
                }
            }

            return [ 
                {
                    name: "Part A Score - Inattentive Symptoms:",
                    score: scorePartA,
                },
                {
                    name: "Part A Likelihood:",
                    score: likelihood(scorePartA),
                },
                {
                    name: "Part B Score - Hyperactive/Impulsive Symptoms:",
                    score: scorePartB,
                },
                {
                    name: "Part B Likelihood:",
                    score: likelihood(scorePartB),
                },
            ]
        }  else if (props.item==="OCD-YBOCS") {
            function likelihood(score) {
                if (score < 8) {
                    return "Unlikely";
                } else if (score >=8 && score <= 15) {
                    return "Mild";
                } else if (score >=16 && score <= 23) {
                    return "Moderate";
                } else if (score >=24 && score <= 31) {
                    return "Severe"; 
                } else {
                    return "Extreme";
                }
            }
            return [ 
                {
                    name: "Obsessions Score:",
                    score: scorePartA,
                },
                {
                    name: "Compulsions Score:",
                    score: scorePartB,
                },
                {
                    name: "Likelihood:",
                    score: likelihood(scorePartA + scorePartB),
                },
            ]

        } else if (props.item==="ISI") { // If  Insomnia Severity Score
            
            // CALCULATE LIKELIHOOD/SEVERITY OF INSOMNIA 
            function likelihood(score){
                if (score <= 7) {
                    return "No clinically significant insomnia";
                } else if (score >=8 && score <= 14) {
                    return "Subthreshold insomnia";
                } else if (score >=15 && score <= 21) {
                    return "Clinical insomnia (moderate severity)";
                } else {
                    return "Clinical insomnia (severe)";
                }
            }

            return [ 
                {
                    name: "Score:",
                    score: scorePartA,
                },
                {
                    name: "Interpretation:",
                    score: likelihood(scorePartA),
                },
            ]
        }  
        else if (props.item==="HAMD") { // If  Insomnia Severity Score
            
            // CALCULATE LIKELIHOOD/SEVERITY OF DEPRESSION
            function likelihood(score){
                if (score <= 7) {
                    return "Normal";
                } else if (score >=8 && score <= 13) {
                    return "Mild Depression";
                } else if (score >=14 && score <= 18) {
                    return "Moderate Depression";
                } else if (score >=19 && score <= 22) {
                    return "Severe Depression";
                } else {
                    return "Very Severe Depression";
                }
            }

            return [ 
                {
                    name: "Score:",
                    score: scorePartA,
                },
                {
                    name: "Interpretation:",
                    score: likelihood(scorePartA),
                },
            ]
        }  
        else {
            return []; // IF NOT DEFINED, EMPTY ARRAY
        }
    }

    // HANDLE MODAL FOR PDF
    const handleClickOpenPDF = () => {
        setOpenPDF(true);
    };
    
    const handleClosePDF = () => {
        setOpenPDF(false);
    };
    
    // SHOW SURVEY DATA
    function showSurveyPartA () {
        return surveyPartA.map((question, index)=><QuestionCard type={data.type} number={index+1} question={question} onAnswerClick={handleAnswerSurveyAClick} key={question.text} onExplanationClick={handleExplanationSurveyAClick}/>
                             )};
    function showSurveyPartB () {
        return surveyPartB.map((question, index)=><QuestionCard type={data.type} number={index+surveyPartA.length+1} question={question} onAnswerClick={handleAnswerSurveyBClick} key={question.text} onExplanationClick={handleExplanationSurveyBClick}/>
                             )};
    
    // DISPLAY SCORE DATA
    function showScoreData() {
        const scoreTypes = scoreTypeData();
        return scoreTypes.map((scoreType)=><Grid item xs={12} key={scoreType.name}><Typography variant="h6" color="secondary" key={scoreType.name}>{scoreType.name} {scoreType.score}</Typography></Grid>);
                            };
                            
     
    
    // HANDLE FORM FUNCTIONS...ETC
    function handleFormSubmit(event) {
        //console.log("Form submitted");
        event.preventDefault();
        handleClickOpenPDF();
    }

    function handleHomeClick() {
        history.push("/");
    }
    
    function handleAnswerSurveyAClick(selectedQuestion, newChoice){
        const newSurveyA = surveyPartA.map((question)=>{
            return (question.text !== selectedQuestion.text) ? question : {text: question.text, answers: question.answers, choice: newChoice, explanation: question.explanation};
        });
        setSurveyPartA (newSurveyA);
    }
    
    function handleAnswerSurveyBClick(selectedQuestion, newChoice){
        const newSurveyB = surveyPartB.map((question)=>{
            return (question.text !== selectedQuestion.text) ? question : {text: question.text, answers: question.answers, choice: newChoice, explanation: question.explanation};
        });
        setSurveyPartB (newSurveyB);
    }

    function handleExplanationSurveyAClick(selectedQuestion, newExplanation) {
        const newSurveyA = surveyPartA.map((question)=>{
            return (question.text !== selectedQuestion.text) ? question : {text: question.text, answers: question.answers, choice: question.choice, explanation: newExplanation};
        });
        setSurveyPartA (newSurveyA);
    }

    function handleExplanationSurveyBClick(selectedQuestion, newExplanation) {
        const newSurveyB = surveyPartB.map((question)=>{
            return (question.text !== selectedQuestion.text) ? question : {text: question.text, answers: question.answers, choice: question.choice, explanation: newExplanation};
        });
        setSurveyPartB (newSurveyB);
    }

    // DISPLAY/RETURN  SCREEN

    return <>
        <div className={classes.root}>
            <form onSubmit={handleFormSubmit}>
                <div className={classes.extendedIcon}>
                    <Fab variant="extended" id="submit" type="submit" name="submit">Create PDF</Fab>
                    {" "}
                    <Fab variant="extended" id="return" name="return" onClick={handleHomeClick}>Return</Fab>
                </div>
                <Header title={data.title} subTitle={data.subTitle} />
                <Grid container spacing={3}>
                     <Grid item>
                        <Box>
                            <Typography variant="subtitle1" color="inherit">{data.instructions}</Typography>
                            <Typography variant="subtitle1" color="inherit"><strong>Press CREATE PDF to render a PDF document you can send to your provider.</strong></Typography>
                            <Typography variant="subtitle1" color="inherit"><em>Explanations are optional.</em></Typography>
                        </Box>
                    </Grid>
                </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12}><Typography variant="h5" color="inherit">{data.sectionTitles[0]}</Typography></Grid>
                <Grid item xs={12}><Typography variant="subtitle1" color="inherit">{data.sectionSubTitles[0]}</Typography></Grid>
                    {showSurveyPartA()}
                <Grid item xs={12}><Typography variant="h5" color="inherit">{data.sectionTitles[1]}</Typography></Grid>
                <Grid item xs={12}><Typography variant="subtitle1" color="inherit">{data.sectionSubTitles[1]}</Typography></Grid>
                    {showSurveyPartB()}
                    {showScoreData()}
            </Grid>
        </form>
        <Disclaimers />
        </div>
        <Dialog fullScreen open={openPDF} onClose={handleClosePDF} TransitionComponent={Transition}>
            <SurveyTwoPartPDF displayData={data} surveyPartA={surveyPartA} surveyPartB={surveyPartB} scoreData={scoreTypeData()} onReturnClick={handleClosePDF}/>
        </Dialog>
        <Snackbar open={privacyOpen} onClose={handlePrivacyAgreeClose} message={<React.Fragment>Please note that this website is for personal use only. Review our <Link onClick={(e)=>e.preventDefault} href="/privacy-policy" target="_blank">Privacy Policy</Link> for details. Agree to acknowledge and proceed.</React.Fragment>} action={<Button variant="contained" color="primary" onClick={handlePrivacyAgreeClose}>AGREEE</Button>}/>
    </>;
}

    /*  Original disclaimer
} <ConfirmDialog title={"Privacy Disclaimer"} description={<>Psych Apps does not encrypt data and cannot guarantee security of sensitive information. By continuing, you acknowledge understanding and acceptance of the privacy disclaimer and <Link onClick={(e)=>e.preventDefault} href="/privacy-policy" target="_blank">policy.</Link></>} agree={"Agree and Continue"} disagree={"Return"} open={privacyOpen} onCloseClick={handlePrivacyDisagreeClose} onAgreeClick={handlePrivacyAgreeClose}/> */

